export const VK_LINK = 'https://vk.com/dotaloot';
export const TG_LINK = 'https://t.me/dotaloot';
